export const pollApi = (apiFn, onSuccess, onError, intervals) => {
  let attempt = 0;

  const poll = () => {
    apiFn()
      .then((response) => {
        if (response?.data?.success === true) {
          onSuccess(response);
        } else {
          attempt++;
          if (attempt < intervals.length) {
            setTimeout(poll, intervals[attempt]);
          } else {
            onError();
          }
        }
      })
      .catch(() => {
        attempt++;
        if (attempt < intervals.length) {
          setTimeout(poll, intervals[attempt]);
        } else {
          onError();
        }
      });
  };

  // Start polling with the first interval
  setTimeout(poll, intervals[attempt]);
};
